// This is the root reducer of the feature. It is used for:
//   1. Load reducers from each action in the feature and process them one by one.
//      Note that this part of code is mainly maintained by Rekit, you usually don't need to edit them.
//   2. Write cross-topic reducers. If a reducer is not bound to some specific action.
//      Then it could be written here.
// Learn more from the introduction of this approach:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da.

import initialState from './initialState';
import { reducer as getMyTripsBusReducer } from './getMyTripsBus';
import { reducer as getMyTransactionsReducer } from './getMyTransactions';
import { reducer as getVirtualMoneyReducer } from './getVirtualMoney';
import { reducer as walletRechargeReducer } from './walletRecharge';
import { reducer as getRechargeLocationsReducer } from './getRechargeLocations';
import { reducer as getCustomerInfoReducer } from './getCustomerInfo';
import { reducer as updateFavouritesReducer } from './updateFavourites';
import { reducer as getProfileReducer } from './getProfile';
import { reducer as transferMoneyReducer } from './transferMoney';
import { reducer as getQrReducer } from './getQr';
import { reducer as getPoolTripsReducer } from './getPoolTrips';
import { reducer as getKuposGoTripsReducer } from './getKuposGoTrips';
import { reducer as getMyAtTripsReducer } from './getMyAtTrips';
import { reducer as getMyTrainTripsReducer } from './getMyTrainTrips';
import { reducer as addBipCardReducer } from './addBipCard';
import { reducer as apiCallReducer } from './apiCall';
import { reducer as saveBipDetailsReducer } from './saveBipDetails';

const reducers = [
  getMyTripsBusReducer,
  getMyTransactionsReducer,
  getVirtualMoneyReducer,
  walletRechargeReducer,
  getRechargeLocationsReducer,
  getCustomerInfoReducer,
  updateFavouritesReducer,
  getProfileReducer,
  transferMoneyReducer,
  getQrReducer,
  getPoolTripsReducer,
  getKuposGoTripsReducer,
  getMyAtTripsReducer,
  getMyTrainTripsReducer,
  addBipCardReducer,
  apiCallReducer,
  saveBipDetailsReducer,
];

export default function reducer(state = initialState, action) {
  let newState;
  switch (action.type) {
    // Handle cross-topic actions here
    default:
      newState = state;
      break;
  }
  return reducers.reduce((s, r) => r(s, action), newState);
}



// WEBPACK FOOTER //
// ./src/features/my-account/redux/reducer.js